export const ORDERS_PAGE_SIZE = 20;
